<div class="modal-body text-center">
  <p>{{confirmMessage}}</p>
  <button type="button" class="btn btn-primary mr-2" (click)="confirm()">{{ 'Eliminar' | translate}}</button>
  <button type="button" class="btn btn-light" (click)="decline()">{{ 'Cancelar' | translate}}</button>
</div>
